export const Message = {
  sendTimingNames: new Map([
    ['now', '즉시'],
    ['atReservedTime', '예약'],
  ]),
};
